<template>
    <graph ref="chart" :chart-data="chart_data" />
</template>

<script type="text/javascript">
import graph_component from "./GraphComponent"

import Graph from "./ProposalHitRateGraph.js"

export default {
    mixins: [graph_component],
    components: {
        Graph
    },
    methods: {},
    computed: {
        chart_data () {
            const chart_data = {
                labels: [],
                datasets: [
                    { label: "Prospective", backgroundColor: this.color_new.background, borderColor: this.color_new.background, fill: false, data: [], _total: 0 },
                    { label: "Active", backgroundColor: this.color_active.background, borderColor: this.color_active.background, fill: false, data: [], _total: 0 }
                ]
            }

            let dates = Object.keys(this.rawData)
            if(this.filter === "weeks") dates = dates.slice(-6)

            let month = -1
            dates.forEach(date_string => {
                const data = this.rawData[date_string]
                if(this.filter === "weeks") {
                    chart_data.datasets[0].data.push(0)
                    chart_data.datasets[1].data.push(0)
                    chart_data.labels.push(date_string)
                } else {
                    const date = this.$moment(date_string)
                    const date_month = date.month()
                    if(month !== date_month) {
                        date_string = date.startOf("month").format("MMM Y")
                        chart_data.labels.push(date_string)
                        chart_data.datasets[0].data.push(0)
                        chart_data.datasets[1].data.push(0)
                        month = date_month
                    }
                }

                const index = chart_data.datasets[0].data.length - 1
                chart_data.datasets[0].data[index] += data.prospective
                chart_data.datasets[0].data[index] += data.prospective
                chart_data.datasets[0]._total += data.prospective

                chart_data.datasets[1].data[index] += data.active
                chart_data.datasets[1]._total += data.active
            })

            return chart_data
        }
    }
}
</script>
